import { render, staticRenderFns } from "./VerifInstProt.vue?vue&type=template&id=6d7fd80c&scoped=true"
import script from "./VerifInstProt.vue?vue&type=script&lang=js"
export * from "./VerifInstProt.vue?vue&type=script&lang=js"
import style0 from "./VerifInstProt.vue?vue&type=style&index=0&id=6d7fd80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7fd80c",
  null
  
)

export default component.exports